"use client";
import Image from "@/components/atoms/image";
import { Breadcrumb as AgoraBreadcrumb } from "@ama-pt/agora-design-system";
import { useMediaQuery } from "@/hooks/useMediaQuery";

interface BreadcrumbItem {
  doc: {
    title: string;
    slug: string;
  };
  url: string;
  label: string;
}

interface BreadcrumbProps {
  breadcrumbs: BreadcrumbItem[];
  breadcrumbImage?: {
    alt: string;
    url: string;
  };
  tabletBreadcrumbImage?: {
    alt: string;
    url: string;
  };
  mobileBreadcrumbImage?: {
    alt: string;
    url: string;
  };
}

const Breadcrumb = ({
  breadcrumbs,
  breadcrumbImage,
  tabletBreadcrumbImage,
  mobileBreadcrumbImage,
}: BreadcrumbProps) => {
  const { isDesktop, isMobile, isTablet } = useMediaQuery();
  const hasImage =
    breadcrumbImage?.url !== "" ||
    tabletBreadcrumbImage?.url !== "" ||
    mobileBreadcrumbImage?.url !== "";

  const correctedBreadcrumbs = breadcrumbs.map((item, index) => ({
    ...item,
    url: index === 0 ? "/" : `/${item.doc.slug}`,
  }));

  return (
    <section className="w-full">
      <div
        className={`relative w-full ${
          hasImage
            ? "h-[475px] md:h-[500px] xl:h-[520px] hero-clip-path"
            : "py-[12px] md:py-24"
        }`}
      >
        <div
          className={`${
            hasImage ? "absolute top-32 md:top-10 xl:top-12 w-full z-10" : ""
          }`}
        >
          <div className="container mx-auto flex">
            <AgoraBreadcrumb
              darkMode={hasImage}
              className="!text-white"
              items={correctedBreadcrumbs}
            />
          </div>
        </div>

        {hasImage && (
          <div className="absolute inset-0 w-full h-full">
            <Image
              src={
                (isDesktop
                  ? breadcrumbImage?.url
                  : isTablet
                  ? tabletBreadcrumbImage?.url
                  : isMobile
                  ? mobileBreadcrumbImage?.url
                  : breadcrumbImage?.url) || ""
              }
              alt={breadcrumbImage?.alt || "Hero"}
              fill
              className="object-cover !h-auto"
              priority
              quality={100}
              sizes="100vw"
              unoptimized={false}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default Breadcrumb;
